import React from "react";
import { cn } from "@/lib/utils";

type PageHeaderProps = {
  icon?: React.ComponentType<{ className?: string }>;
  title: string;
  /** Optional small badge rendered right after the title (e.g. a "beta" pill). */
  badge?: React.ReactNode;
  description?: string;
  actions?: React.ReactNode;
  className?: string;
};

export function PageHeader({ icon: Icon, title, badge, description, actions, className }: PageHeaderProps) {
  return (
    <div
      className={cn(
        "flex items-center justify-between gap-4",
        "rounded-lg border border-border px-3 py-2 shadow-sm",
        className
      )}
      style={{ background: "linear-gradient(90deg, hsl(var(--muted) / 0.68), hsl(var(--card) / 0.82))" }}
    >
      <div className="flex items-center gap-2.5 min-w-0">
        {Icon && (
          <div className="flex h-5 w-5 shrink-0 items-center justify-center rounded bg-primary/15">
            <Icon className="h-3 w-3 text-primary" />
          </div>
        )}
        <h1 className="whitespace-nowrap text-sm font-semibold bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent">
          {title}
        </h1>
        {badge}
        {description && (
          <>
            <span className="select-none text-xs text-muted-foreground/30">·</span>
            <p className="truncate text-xs text-muted-foreground/80">{description}</p>
          </>
        )}
      </div>
      {actions && <div className="shrink-0">{actions}</div>}
    </div>
  );
}
